import { MacroItem, TemplateMacroTableProps } from '@/template/interface'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { Space, Table } from 'antd'
import React from 'react'

export const TemplateMacroTable: React.FC<TemplateMacroTableProps> = (
  props: TemplateMacroTableProps
) => {
  const formatMessage = getFormatMessage()
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.template.macro.table.index' }),
      key: 'app.template.macro.table.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.template.macro.table.name' }),
      key: 'app.template.macro.table.name',
      dataIndex: 'name'
    },
    {
      title: formatMessage({ id: 'app.template.macro.table.description' }),
      key: 'app.template.macro.table.description',
      dataIndex: 'description'
    },
    {
      title: formatMessage({ id: 'app.template.macro.table.operation' }),
      key: 'app.template.macro.table.operation',
      render: (text: any, record: MacroItem) => (
        <Space size='middle'>
          <a onClick={() => props.onEdit?.(record)}>
            {formatMessage({ id: 'app.template.macro.table.operation.edit' })}
          </a>
          <a onClick={() => props.onDelete?.(record)}>
            {formatMessage({ id: 'app.template.macro.table.operation.delete' })}
          </a>
        </Space>
      )
    }
  ]
  const columns = mergeTableColumns(defaultColumns, props.columns)
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (props.onSelect) {
        props.onSelect(selectedRows)
      }
    }
  }

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
      rowSelection={
        props.selectable
          ? {
              type: props.selectionType,
              ...rowSelection
            }
          : undefined
      }
    />
  )
}
